<template>
    <div>
        <h1 class="display-heading">Company Registered Employees</h1>

        <div class="table-responsive">
            <table class="table table-hover">
                <thead>
                    <tr>
                        <th scope="col">#</th>
                        <th scope="col">Full Name</th>
                        <th scope="col">Email Address</th>
                        <th scope="col">Phone Number</th>
                        <th scope="col">Role</th>
                    </tr>
                </thead>

                <tbody>
                    <tr v-for="(user, index) in userList" :key="index">
                        <th scope="row">{{index+1}}</th>
                        <td>{{user.fullName}}</td>
                        <td>
                            {{user.email}}
                        </td>
                        <td>{{user.phoneNumber}}</td>
                        <td>
                            {{user.role}}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
export default {
    data () {
        return {
            'userList': []
        };
    },
    mounted () {
        this.axios.get('/company/users').then(({
            data
        }) => {
            this.userList = data.data.map((user) => ({
                'fullName': user.f ? user.f : '-',
                'email': user.e ? user.e : '-',
                'phoneNumber': user.p ? user.p : '-',
                'role': user.r === 1 ? 'User' : user.r === 4 ? 'Admin' : 'User'
            }));
        })
            .catch(({
                response
            }) => {

            });
    }
};

</script>

<style>

</style>
